/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TestStepValueDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    testStepValueType: TestStepValueDto.testStepValueType;
    testStepId: string;
};
export namespace TestStepValueDto {
    export enum testStepValueType {
        BOOLEAN = 'BOOLEAN',
        NUMERIC = 'NUMERIC',
        STRING = 'STRING',
        SELECTION = 'SELECTION',
        DATE = 'DATE',
    }
}

